<template>
    <div class="wrapper-card">
        <div class="sidenav-wrapper" v-if="width > 1000">
            <SideNav :venueSubscription.sync="venueSubscription" />
        </div>
        <div class="content-wrapper">
            <EventManageHeader
                :counterOfferData.sync="counterOfferData"
                :eventStatus.sync="eventStatus"
                :eventId="eventId"
            />
            <div class="bottom-line-up"></div>
            <div v-if="offerMode === 'showAll'" class="w-100">
                <ArtistBooked
                    :eventStatus="eventStatus"
                    :eventId="eventId"
                    :venue-id="venueId"
                />
                <OffersToReviews
                    :declineInfo.sync="declineInfo"
                    :artistInfo="artistInfo"
                    :bidArtist.sync="bidArtist"
                    :offerMode.sync="offerMode"
                    :eventId="eventId"
                    @open-invite="handleOpenInvite"
                />
                <DeclineArtist
                    :declineInfo="declineInfo"
                    :artistInfo.sync="artistInfo"
                    :eventId="eventId"
                />
            </div>
            <div class="content" v-if="offerMode === 'showOffer'">
                <ReviewOffersPage :offerMode.sync="offerMode" :bidArtist.sync="bidArtist" />
                <ArtistOffer
                    :venueSubscription="venueSubscription"
                    :counterOfferData="counterOfferData"
                    :eventId="eventId"
                    :venue-id="venueId"
                    :counter="counter"
                    :bidArtist.sync="bidArtist"
                />
            </div>
        </div>
        <InviteThroughSearch
            :showModal.sync="openInvite"
            :eventId="parseInt(eventId)"
            :bookerId="parseInt(booker)"
        />
    </div>
</template>

<script>
    import EventManageHeader from './EventManageHeader.vue'
    import OffersToReviews from './booked-artist/OffersToReviews.vue'
    import ArtistBooked from './booked-artist/ArtistBooked.vue'
    import DeclineArtist from './booked-artist/DeclineArtist.vue'
    import ReviewOffersPage from './booked-artist/ReviewOffersPage.vue'
    import ArtistOffer from './booked-artist/ArtistOffer.vue'
    import SideNav from '../../parts/SideNav.vue'
    import checkScreen from '../../../mixins/check-screen'
    import InviteThroughSearch from '../../invite-through-search/InviteThroughSearch.vue'
    export default {
        name: 'EventManagePage',
        mixins: [checkScreen],
        props: {
            booker: {
                type: Number,
                required: true
            },
            eventId: {
                type: Number,
                required: true
            },
            venueId: {
                type: Number,
                required: true
            },
            offerMode: {
                type: String,
                default: 'showAll'
            },
            bidArtist: {
                type: Number
            },
            artistInfo: {
                type: Object
            },
            declineInfo: {
                type: Object
            },
            eventStatus: {
                type: Number
            },
            venueSubscription: {
                type: String
            },
            counterOfferData: {
                type: Object
            }
        },
        components: {
            SideNav,
            EventManageHeader,
            OffersToReviews,
            ArtistBooked,
            DeclineArtist,
            ReviewOffersPage,
            ArtistOffer,
            InviteThroughSearch
        },
        data() {
            return {
                counter: false,
                openInvite: false
            }
        },
        methods: {
            handleOpenInvite() {
                this.openInvite = true
            },
            openInviteIfNeeded() {
                const params = new URL(window.location.toString()).searchParams
                const invite = JSON.parse(params.get('inviteArtist'))

                if (invite) {
                    this.handleOpenInvite()
                }
            }
        },
        mounted() {
            const bidArtistId = JSON.parse(localStorage.getItem('bidArtist'))
            const editOffer = JSON.parse(localStorage.getItem('editOffer'))

            if (bidArtistId && editOffer) {
                this.bidArtist = bidArtistId
                this.offerMode = 'showOffer'
                this.counter = true
            }
            const openInvite = localStorage.getItem('open-invite')

            openInvite ? (this.openInvite = JSON.parse(openInvite)) : (this.openInvite = false)

            localStorage.removeItem('open-invite')
            localStorage.removeItem('bidArtist')
            localStorage.removeItem('editOffer')
            localStorage.removeItem('getStartedStep')
            this.openInviteIfNeeded()
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrapper {
        flex: 0 1 90%;
    }
    .content {
        max-width: 1050px;

        @media screen and (max-width: 1100px) {
            max-width: 770px;
        }
    }
    .wrapper-card {
        max-width: 100%;
        overflow: hidden;
    }
    .wrapper-card {
        display: flex;
        background: #000;
        align-items: flex-start;
        padding: 50px;
        gap: 58px;
    }
    .bottom-line-up {
        display: flex;
        flex-direction: row;
        border: 1px solid #646464;
        width: 100%;
        max-width: 1050px;
        margin-top: 50px;
        margin-bottom: 50px;
    }

    @media (max-width: 600px) {
        .wrapper-card {
            padding: 0;
            display: inherit;
        }
        .bottom-line-up {
            margin: 50px 16px;
        }
    }
</style>
